export const transactionFields = {
  ID: 'id',
  TYPE: 'transactionType',
  GAS: 'gas',
  CREATE_TIME: 'transactionCreateTime',
  GO_AMOUNT: 'transactionGoAmount',
  GO_INFORMATION: 'goInformation',
  SENDER_ACCOUNT: 'fromAccount',
  SENDER: 'sender',
  RECEIVER: 'receiver',
  END_DATE: 'endDate',
  START_DATE: 'startDate',
  STATUS: 'status',
  HISTORY: 'history',
  COMMENT: 'comment',
  MANUAL_ISSUE: 'manualIssue',
  SENDER_INFORMATION: 'senderInformation',
  RECEIVER_INFORMATION: 'receiverInformation',
  CONSUMER_INFORMATION: 'consumerInformation',
  CONSUMPTION_INFORMATION: 'consumptionInformation',
  CAN_RECALL: 'canBeRecalled',
  CAN_SEND_VDS_REQUEST: 'canSendVdsRequest',
  GOS_PRICE: 'gosPrice',
  EXPORT_TRANSACTION_GO_INFORMATION: 'exportTransactionGoInformation',
  IS_EECS_GO_TRANSACTION: 'eecsGoTransaction',
  AIB_TRANSACTION_NUMBER: 'aibTransactionNumber',
  EXTERNAL_TRANSACTION_AIB_LOG_LIST: 'externalTransactionAibLogList',
};

export const transactionAccountFields = {
  ID: 'id',
  COMPANY: 'companyName',
};

export const transactionReceiverFields = {
  COUNTRY: 'country',
  RECEIVER: 'receiver',
  NAME: 'name',
  CODE: 'code',
  EECS_CODE: 'eecsCode',
};

export const transactionHistoryFields = {
  ID: 'id',
  END_TIME: 'endTime',
  START_TIME: 'startTime',
  STATUS: 'status',
  TRANSACTION: 'transaction',
};

export const transactionEGOInfoFields = {
  GO_AMOUNT: 'goAmount',
  START_BALANCE: 'startBalance',
  END_BALANCE: 'endBalance',
  ISSUE_PERIOD: 'issuePeriod',
  UNIT_EICX: 'unitEicx',
  TECHNOLOGY: 'technology',
  FUEL_TYPE: 'fuelType',
  HYDROGEN_FUEL_TYPE: 'hydrogenFuelType',
  SENDING_ACCOUNT_ID: 'sendingAccountId',
};

export const transactionEecsGOInfoFields = {
  GO_AMOUNT: 'goAmount',
  PRODUCTION_PERIOD: 'productionPeriod',
  UNIT_EECS_CODE: 'unitEecsCode',
  PRODUCTION_TECHNOLOGY: 'productionTechnology',
  FEEDSTOCK: 'feedstock',
};

export const transactionParticipantFields = {
  NAME: 'name',
  CODE: 'code',
  EECS_CODE: 'eecsCode',
};

export const transactionConsumerFields = {
  NAME: 'name',
  CODE: 'code',
  EICX: 'eicx',
  ACCOUNT_NUMBER: 'accountNumber',
  CONSUMER_TYPE: 'consumerType',
};

export const transactionConsumptionFields = {
  ADDRESS: 'address',
  CONSUMED_AMOUNT: 'consumedAmount',
  CONSUMPTION_USAGE: 'consumptionUsage',
  DATA_SOURCE: 'dataSource',
  METERING_EIXZ: 'meteringPointEixz',
  PERIOD: 'period',
};
